import { Collapse, CollapseProps } from "@chakra-ui/react"
import { Ref, useRef } from "react"

export const CustomCollapse = ({ children, ...props }: CollapseProps) => {
    const ref = useRef<HTMLDivElement>()
    if (ref.current) ref.current.style.overflow = 'visible'

    return (
        <Collapse {...props} ref={ref as Ref<HTMLDivElement>}>
            {children}
        </Collapse>
    )
}